import { render } from "./offerInfo.vue?vue&type=template&id=2ecbbe56&scoped=true"
import script from "./offerInfo.vue?vue&type=script&lang=js"
export * from "./offerInfo.vue?vue&type=script&lang=js"

import "./offerInfo.vue?vue&type=style&index=0&id=2ecbbe56&lang=less&scoped=true"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecbbe56"]])

export default __exports__